export const ASSETS_LOCATION = {
  UI: "/assets/images/ui/",
  CHANNELS: "/assets/images/channels/",
};

export const PAYMENT_ASSETS = {
  Visa: {
    logo: `${ASSETS_LOCATION.UI}payment-logo-visa.png`,
    background: `${ASSETS_LOCATION.UI}payment-logo-visa.png`,
  },
  MasterCard: {
    logo: `${ASSETS_LOCATION.UI}payment-logo-mastercard-full.png`,
    background: `${ASSETS_LOCATION.UI}payment-logo-mastercard.png`,
  },
  ADD_NEW: {
    logo: `${ASSETS_LOCATION.UI}payment-icon-cards.svg`,
  },
  DEFAULT: {
    logo: `${ASSETS_LOCATION.UI}payment-logo-card-generic.svg`,
  },
};

export const ICONS = {
  ALERT: `${ASSETS_LOCATION.UI}icon-bell.svg`,
  ARROW_LEFT: `${ASSETS_LOCATION.UI}icon-arrow-left.svg`,
  CALENDAR: `${ASSETS_LOCATION.UI}icon-calendar.svg`,
  CLOSE: `${ASSETS_LOCATION.UI}close.svg`,
  CLOSE_WHITE: `${ASSETS_LOCATION.UI}close-white.svg`,
  EDIT: `${ASSETS_LOCATION.UI}icon-edit.svg`,
  DOWN_ARROW: `${ASSETS_LOCATION.UI}down-arrow.svg`,
  MINUS: `${ASSETS_LOCATION.UI}icon-minus.svg`,
  PLUS: `${ASSETS_LOCATION.UI}icon-plus.svg`,
  PROMO_CODE: `${ASSETS_LOCATION.UI}promo-code.svg`,
  PROMO_CODE_DARK: `${ASSETS_LOCATION.UI}promo-code-grey.svg`,
  WARNING: `${ASSETS_LOCATION.UI}icon-warning.svg`,
  CHEVRONS_LEFT: `${ASSETS_LOCATION.UI}chevrons-left.svg`,
  CHEVRONS_RIGHT: `${ASSETS_LOCATION.UI}chevrons-right.svg`,
};

// TECH DEBT: hardcoded brand conditional show terms link(s)
export const BRAND_CONDITIONALS = {
  TRACFONE_DEALER_LOYALTY_PROGRAM: ["Total Wireless Stores", "Auth Retailer - TWS"],
};

export const CHANNELS = {
  ASSETS_ROOT: "/assets/images/channels/",
  SOCIAL: "SOCIAL",
  DISPLAY: "DISPLAY",
  DIRECTIONAL: "DIRECTIONAL",
  STREAMING_TV: "STREAMING_TV",
  STREAMING_VIDEO: "STREAMING_VIDEO",
  STREAMING_RADIO: "STREAMING_RADIO",
};

export const CHANNELS_ICONS = {
  SOCIAL: ["icon-channel-Facebook.jpg", "icon-channel-Instagram.jpg", "icon-channel-Snapchat.png"],
  DISPLAY: ["icon-channel-Display.jpg"],
  DIRECTIONAL: ["icon-channel-Waze.jpg"],
  STREAMING_TV: ["icon-channel-Streaming-TV.jpg"],
  STREAMING_VIDEO: ["icon-channel-YouTube.jpg"],
  STREAMING_VIDEO_GENERIC: ["icon-channel-video-generic.jpg"],
  STREAMING_RADIO: ["icon-channel-iHeart-Radio.jpg"],
};
